import {Component} from '@angular/core';
import {MatIconModule} from '@angular/material/icon';
import {TranslateModule} from '@ngx-translate/core';
import {ConfigService} from '@q9elements/ui-kit/common';
import {PlaceholderModule, PrimaryButtonComponent} from '@q9elements/ui-kit/components';

@Component({
  standalone: true,
  selector: 'q9sys-not-found',
  template: `
    <q9-placeholder>
      <q9-placeholder-animation animation="404-page"></q9-placeholder-animation>
      <span q9PlaceholderText>{{ 'CORE.NOT_FOUND.TEXT_404' | translate }}</span>
      <span q9PlaceholderSubtext>{{ 'CORE.NOT_FOUND.SUBTEXT_404' | translate }}</span>
      <q9-primary-button color="primary" q9PlaceholderButton (click)="toMainApp()">
        {{ 'CORE.NOT_FOUND.BUTTON_TEXT_404' | translate }}
      </q9-primary-button>
    </q9-placeholder>
  `,
  imports: [PlaceholderModule, MatIconModule, PrimaryButtonComponent, TranslateModule],
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent {
  toMainApp() {
    window.location.href = ConfigService.environment.MAIN_APP_URL || '';
  }
}
